import { Store } from '@ngrx/store';
import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { ProductExportation } from '../../../Models/product-exportation.interface';
import { ProductToExportation } from '../../../reducers/products-exportation.reducer';
import * as fromAddProductToExportation from '../../../actions/products-exportation.action';
import * as fromProductToExportationSelector from '../../../reducers/products-exportation.reducer';
import { ProductCurrencyEnum } from '../../../enums/product-currency.enum';
import { CurrencyMaskConfig } from 'ng2-currency-mask';

@Component({
  selector: 'app-product-exportation-grid',
  templateUrl: './product-exportation-grid.component.html',
  styleUrls: ['./product-exportation-grid.component.scss']
})
export class ProductExportationGridComponent implements OnInit {
  constructor(private readonly productExportationStore: Store<{ productToExportation: ProductToExportation[] }>) {}

  @Input() dataSource: ProductToExportation[] = [];
  @Input() readonlyGrid: boolean = false;
  @Input() canEdit: boolean = true;
  @Input() isEditProduct: boolean = false;
  @Input() isNewTrade: boolean = false;
  @Input() useProductValue: boolean = false;
  @Input() isOriginCertificate: boolean = false;
  @Input() globalCurrency: ProductCurrencyEnum;

  @ViewChild(MatTable) table: MatTable<any>;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  @Output() deletedProduct = new EventEmitter<ProductExportation>();
  @Output() editProductEvent = new EventEmitter<number>();
  @Output() upProductEvent = new EventEmitter<number>();
  @Output() downProductEvent = new EventEmitter<number>();
  @Output() iseditProductEvent = new EventEmitter<boolean>();

  public displayedColumns: string[] = [];
  public totalWeight: number = 0;
  public totalNetWeight: number = 0;
  public Currency = ['BRL', 'USD', 'EUR'];
  productToExportation: ProductToExportation[] = [];
  datasource = new MatTableDataSource<ProductToExportation>([]);

  ngOnInit(): void {
    this.displayedColumns = ['ncm', 'amount', 'unit', 'grossWeight', 'netWeight', 'marks', 'sif', 'productionDate', 'expirationDate', 'description'];

    if (!this.readonlyGrid) {
      this.displayedColumns.push('actions');
    }
    // add the product value column right before description column
    if (this.useProductValue) {
      this.displayedColumns.splice(9, 0, 'productValue');
    }

    this.productExportationStore.select(fromProductToExportationSelector.getProductToExportation).subscribe((_productToExportation: ProductToExportation[]) => {
      this.datasource = new MatTableDataSource<ProductToExportation>(this.dataSource);
      this.datasource.paginator = this.paginator;
      if (this.table) {
        this.table.renderRows();
      }
      this.calculateTotalWeight();
    });
  }

  getCurrencySymbol(currency: ProductCurrencyEnum, value: number): string {
    let config: CurrencyMaskConfig;
    switch (currency) {
      case ProductCurrencyEnum.REAL:
        config = { prefix: 'R$ ', thousands: '.', decimal: ',', precision: 2, allowNegative: true, align: 'right', suffix: '' };
        break;
      case ProductCurrencyEnum.EURO:
        config = { prefix: '€ ', thousands: '.', decimal: ',', precision: 2, allowNegative: true, align: 'right', suffix: '' };
        break;
      default:
        config = { prefix: '$ ', thousands: ',', decimal: '.', precision: 2, allowNegative: true, align: 'right', suffix: '' };
    }

    const [integerPart, decimalPart] = value.toFixed(config.precision).split('.');
    const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, config.thousands);
    const paddedDecimal = decimalPart.padEnd(config.precision, '0');
    return `${config.prefix}${formattedInteger}${config.decimal}${paddedDecimal}`;
  }

  checkEdit(): boolean {
    if (this.canEdit) {
      return true;
    } else {
      return this.canEdit && !this.readonlyGrid;
    }
  }

  ngDoCheck() {
    this.calculateTotalWeight();
  }

  ngOnChanges(e) {
    if (e.dataSource) {
      if (e.dataSource.currentValue?.length > 0) {
        e.dataSource.currentValue.sort(this.compareteById);
      }
      this.datasource = new MatTableDataSource<ProductToExportation>(e.dataSource.currentValue);
      this.datasource.paginator = this.paginator;
      this.calculateTotalWeight();
      if (this.table) {
        this.table.renderRows();
      }
    }
  }

  compareteById(a, b) {
    if (a.id < b.id) {
      return -1;
    }
    if (a.id > b.id) {
      return 1;
    }
  }
  ngAfterViewInit() {
    this.datasource.paginator = this.paginator;
  }

  public deleteProduct(index) {
    this.deletedProduct.emit(index);
  }

  editProduct(index) {
    this.editProductEvent.emit(index);
  }

  upProduct(index: number) {
    if (index > 0) {
      const product = this.dataSource[index];
      this.dataSource.splice(index, 1);
      this.dataSource.splice(index - 1, 0, product);

      this.productExportationStore.dispatch(fromAddProductToExportation.UpProductToExportation({ _indexOfProductToExportation: index }));
      this.updateDataSource();
    }
  }

  downProduct(index: number) {
    if (index < this.dataSource.length - 1) {
      const product = this.dataSource[index];
      this.dataSource.splice(index, 1);
      this.dataSource.splice(index + 1, 0, product);

      this.productExportationStore.dispatch(fromAddProductToExportation.DownProductToExportation({ _indexOfProductToExportation: index }));
      this.updateDataSource();
    }
  }

  updateDataSource() {
    this.datasource.data = [...this.dataSource];
    if (this.table) {
    }
  }

  public calculateTotalWeight() {
    this.totalWeight = 0;
    this.totalNetWeight = 0;

    if (this.dataSource?.length > 0) {
      this.dataSource.forEach((element) => {
        this.totalWeight += element?.grossWeight || 0;

        this.totalNetWeight += element?.netWeight || 0;
      });
      this.totalWeight = Number(this.totalWeight.toFixed(4));
      this.totalNetWeight = Number(this.totalNetWeight.toFixed(4));
    }
  }
}
